export function DividerWithLabel({ label, classes }: { label: string; classes: any }) {
  return (
    <div className={classes.dividerLabel}>
      <div className={classes.dividerLine} />
      <span>{label}</span>
      <div className={classes.dividerLine} />
    </div>
  );
}